import {Card, Button, Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';

import React from 'react';

import {StyledCardActions} from './styles';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useNavigate} from 'react-router-dom';
import {FacialBiometricEnum} from 'presentation/constants';
import {FacialBiometricsTaggingEnum} from 'main/analytics/gaTagsEnum';

const {registerFacialBiometry, register} =
	translations['pt-br'].privateFlow.myAppointments.appointmentCard.teleHealth;

export function FacialBiometricsCard() {
	const navigate = useNavigate();

	return (
		<Card elevation={0}>
			<Stack
				gap={1}
				alignItems="center"
				justifyContent="space-between"
				padding={2}
				direction="row">
				<Typography>{registerFacialBiometry}</Typography>
				<IconIllustration
					variant="primary"
					size="small"
					customIconName="facial-recognition"
				/>
			</Stack>
			<StyledCardActions>
				<Button
					onClick={() => navigate(FacialBiometricEnum.FACIAL_BIOMETRIC)}
					variant="text"
					endIcon={<Icon name="arrow-right-filled" />}
					data-tag-id={
						FacialBiometricsTaggingEnum.CLICK_CADASTRAR_BIOMETRIA_FACIAL_AVISOS
					}>
					{register}
				</Button>
			</StyledCardActions>
		</Card>
	);
}
